import "../scss/main.scss";

document.addEventListener("DOMContentLoaded", () => {
	const video = document.querySelector(".header-media__video");
	const toggle = document.querySelector(".header-media__toggle");

	if (!video || !toggle) {
		return;
	}

	const updateState = () => {
		const isPaused = video.paused;
		toggle.classList.toggle("is-paused", isPaused);
		toggle.setAttribute("aria-pressed", isPaused ? "true" : "false");
		toggle.setAttribute(
			"aria-label",
			isPaused ? "Lire la vidéo" : "Mettre la vidéo en pause"
		);
	};

	toggle.addEventListener("click", () => {
		if (video.paused) {
			video.play();
		} else {
			video.pause();
		}
	});

	// Assume autoplay first, then sync once playback state is known.
	if (video.autoplay) {
		toggle.classList.remove("is-paused");
		toggle.setAttribute("aria-pressed", "false");
		toggle.setAttribute("aria-label", "Mettre la vidéo en pause");
	}

	video.addEventListener("play", updateState);
	video.addEventListener("pause", updateState);
	video.addEventListener("loadeddata", updateState);

	setTimeout(updateState, 300);
});

document.addEventListener("DOMContentLoaded", () => {
	if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
		return;
	}

	// Sections hors pied de page (#footer = section dans le template part footer)
	const sections = document.querySelectorAll(
		"section:not(#footer):not(#footer section)"
	);
	if (!sections.length) {
		return;
	}

	sections.forEach((section) => {
		section.classList.add("reveal-section");
		Array.from(section.children).forEach((child, index) => {
			if (child.nodeType !== 1) {
				return;
			}
			child.style.setProperty("--reveal-delay", `${index * 80}ms`);
		});
	});

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.classList.add("is-revealed");
					observer.unobserve(entry.target);
				}
			});
		},
		{ threshold: 0.15, rootMargin: "0px 0px -20% 0px" }
	);

	sections.forEach((section) => observer.observe(section));
});

function initGalleryMasonryGapSync(rootDocument, rootWindow) {
	const galleries = rootDocument.querySelectorAll(
		".wp-block-gallery.is-style-empile-colonnes"
	);
	if (!galleries.length) {
		return;
	}

	const syncGap = (gallery) => {
		const styles = rootWindow.getComputedStyle(gallery);
		const rowGap = styles.rowGap;
		const columnGap = styles.columnGap;

		if (rowGap && rowGap !== "normal" && rowGap !== "0px") {
			gallery.style.setProperty("--ml-gallery-row-gap", rowGap);
		} else {
			gallery.style.removeProperty("--ml-gallery-row-gap");
		}

		if (columnGap && columnGap !== "normal" && columnGap !== "0px") {
			gallery.style.setProperty("--ml-gallery-column-gap", columnGap);
		} else {
			gallery.style.removeProperty("--ml-gallery-column-gap");
		}
	};

	galleries.forEach((gallery) => {
		syncGap(gallery);

		const mo = new MutationObserver(() => syncGap(gallery));
		mo.observe(gallery, { attributes: true, attributeFilter: ["style", "class"] });
	});

	rootWindow.addEventListener(
		"resize",
		() => {
			galleries.forEach((gallery) => syncGap(gallery));
		},
		{ passive: true }
	);
}

/**
 * Pop-in accueil : ouverture au premier événement entre scroll (seuil vh) et délai.
 * Fermeture : réaffiche au prochain chargement (pas de blocage).
 * Après envoi GF réussi (AJAX) : mémorisation localStorage, la popin ne revient plus.
 */
function initHomePopup() {
	const root = document.querySelector("[data-ml-popup]");
	if (!root || !(root instanceof HTMLElement)) {
		return;
	}

	const formId = parseInt(root.dataset.formId || "0", 10);
	const storageKey =
		formId > 0 ? `ml_home_popup_gf_sent_${formId}` : "ml_home_popup_gf_sent_0";

	if (formId > 0 && localStorage.getItem(storageKey) === "1") {
		root.remove();
		return;
	}

	const delayMs = parseInt(root.dataset.delayMs || "5000", 10);
	const scrollVh = parseInt(root.dataset.scrollVh || "50", 10) / 100;
	const dialog = root.querySelector(".ml-home-popup__dialog");
	const closeEls = root.querySelectorAll("[data-ml-popup-close]");

	let opened = false;
	let timerId = 0;
	const scrollOpts = { passive: true };

	const getScrollThreshold = () => window.innerHeight * scrollVh;

	const markFormSentAndRemove = () => {
		if (formId > 0) {
			localStorage.setItem(storageKey, "1");
		}
		document.body.classList.remove("ml-popup-open");
		window.removeEventListener("keydown", onKeydown);
		root.remove();
	};

	const bindGravityConfirmation = () => {
		if (!formId || !window.jQuery) {
			return;
		}
		const $ = window.jQuery;
		$(document).on("gform_confirmation_loaded", (event, fid) => {
			const id = parseInt(String(fid), 10);
			if (id !== formId) {
				return;
			}
			if (!root.querySelector(`#gform_wrapper_${id}`)) {
				return;
			}
			markFormSentAndRemove();
		});
	};

	bindGravityConfirmation();

	const open = () => {
		if (opened) {
			return;
		}
		opened = true;
		if (timerId) {
			clearTimeout(timerId);
			timerId = 0;
		}
		window.removeEventListener("scroll", onScroll, scrollOpts);

		root.setAttribute("data-ml-popup-state", "open");
		root.setAttribute("aria-hidden", "false");
		document.body.classList.add("ml-popup-open");
		window.addEventListener("keydown", onKeydown);

		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				if (dialog instanceof HTMLElement) {
					dialog.focus({ preventScroll: true });
				}
			});
		});

		if (window.jQuery && typeof window.jQuery.fn !== "undefined") {
			const wrap = root.querySelector(".gform_wrapper");
			if (wrap && wrap.id && wrap.id.indexOf("gform_wrapper_") === 0) {
				const fidStr = wrap.id.replace("gform_wrapper_", "");
				const fid = parseInt(fidStr, 10);
				if (!Number.isNaN(fid)) {
					window.jQuery(document).trigger("gform_post_render", [fid, fid]);
				}
			}
		}
	};

	const close = () => {
		root.setAttribute("data-ml-popup-state", "closed");
		root.setAttribute("aria-hidden", "true");
		document.body.classList.remove("ml-popup-open");
		window.removeEventListener("keydown", onKeydown);
	};

	function onScroll() {
		if (window.scrollY >= getScrollThreshold()) {
			open();
		}
	}

	function onKeydown(e) {
		if (e.key === "Escape") {
			close();
		}
	}

	closeEls.forEach((el) => {
		el.addEventListener("click", close);
	});

	window.addEventListener("scroll", onScroll, scrollOpts);
	if (window.scrollY >= getScrollThreshold()) {
		open();
	} else {
		timerId = window.setTimeout(open, delayMs);
	}
}

document.addEventListener("DOMContentLoaded", () => {
	initHomePopup();

	// Front (ou si pas d'iframe éditeur)
	initGalleryMasonryGapSync(document, window);

	// Éditeur Gutenberg (canvas dans une iframe)
	const iframe =
		document.querySelector('iframe[name="editor-canvas"]') ||
		document.querySelector(".block-editor-iframe__container iframe");

	if (!iframe) {
		return;
	}

	const tryInit = () => {
		const doc = iframe.contentDocument;
		const win = iframe.contentWindow;
		if (doc && win) {
			initGalleryMasonryGapSync(doc, win);
		}
	};

	if (iframe.contentDocument?.readyState === "complete") {
		tryInit();
	} else {
		iframe.addEventListener("load", tryInit, { once: true });
	}
});
